import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Button } from './Button'

interface Props {
  toggleSider: () => void
}

export const cvResumeLink = "https://docs.google.com/document/d/1-5sra7y8E3ehxilXQk1ckewu8EpVOVK4i-7oNXAnSFU/edit?usp=sharing"


export const Sidebar = ({toggleSider}: Props) => {
  const navigate = useNavigate()

  return (
    <aside className='sidebar bg-secondary'>
      <p className='text-secondary'
        onClick={() => {
          navigate("/")
          toggleSider()
        }}
      >
        Home
      </p>
      <p className='text-secondary'
        onClick={() => {
          navigate("/projects")
          toggleSider()
        }}
      >
        Projects
      </p>

      <a href={cvResumeLink} target="_blank" rel="noopener noreferrer" 
        className='download-btn'
      >
        
        <Button
          text="Resume"
          btnType='primary'
          className='sidebar-btn'
        />
      </a>
    </aside>
  )
}